import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { isMobileApp } from 'utils';
import { AppSettingsContent } from 'console/app-settings/app-settings';
import { ErrorBoundary } from 'shared/components/error-boundary';
import * as React from 'react';
export const AppConfigPage = () => {
    return (_jsx(ErrorBoundary, { children: _jsx(Box, { display: "flex", flexDirection: "column", gap: 2, overflow: "auto", boxSizing: "border-box", children: _jsx(AppSettingsContent, {}) }) }));
};
AppConfigPage.isShown = () => isMobileApp();
